module.exports = __webpack_public_path__ + "img/logo12.a121737e.png";